import moment from 'moment-timezone';
import { COOKIE_TOKEN_KEY } from './Constants';
import { Closure } from './types';

export const getTokenFromCookies = (): string => {
    const cookie = document.cookie
        .split('; ')
        .find(c => c.startsWith(`${COOKIE_TOKEN_KEY}=`));
    return cookie ? cookie.split('=')[1] : undefined;
};

export const getUpdatedClosure = (closure: Closure<string>): Closure => ({
    ...closure,
    effectiveByDate: moment(closure.effectiveByDate),
    endDate: moment(closure.endDate),
    startDate: moment(closure.startDate)
});
